/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requirement_Complete_ItemInputs */

const en_task_requirement_complete_item = /** @type {(inputs: Task_Requirement_Complete_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete item`)
};

const pt_br2_task_requirement_complete_item = /** @type {(inputs: Task_Requirement_Complete_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir item`)
};

/**
* | output |
* | --- |
* | "Complete item" |
*
* @param {Task_Requirement_Complete_ItemInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requirement_complete_item = /** @type {((inputs?: Task_Requirement_Complete_ItemInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requirement_Complete_ItemInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requirement_complete_item(inputs)
	return pt_br2_task_requirement_complete_item(inputs)
});